/* tslint:disable:interface-name */

/**
 * Generic Dictionary interface
 *
 * @deprecated Use Record<string, T>
 */
export interface Dictionary<T> extends Record<string, T> {
  [key: string]: T;
}

/**
 * Generic dictionary interface for lists of options for a select.
 *
 * Usage:
 *
 * ```ts
 * export const THEME_OPTIONS: OptionDictionary<Theme>[] = [
 *   { text: 'global.theme.light', value: Theme.Light },
 *   { text: 'global.theme.dark', value: Theme.Dark },
 * ];
 * ```
 *
 * ```html
 * <select [(ngModel)]="selectedTheme">
 *   <option *ngFor="let theme of THEME_OPTIONS" [value]="theme.value">
 *     {{ theme.text | translateLegacy }}
 *   </option>
 * </select>
 * ```
 */
export interface OptionDictionary<T> {
  description?: string;
  text: string;
  value: T;
}

/**
 * Parameters values that can be represented in a string format.
 * This parameter values should be able to be represented in http request params, localization etc.
 */
export type ParameterValueType = string | number | boolean | undefined;
